import { Capacitor } from '@capacitor/core';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);
const PRODUCTION_BACKEND_URL = 'https://leaguehub.it';

const trimTrailingSlash = (value = '') => value.trim().replace(/\/$/, '');

export function getBackendBaseUrl() {
  const envUrl = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL || '');

  if (typeof window === 'undefined') {
    return envUrl || 'http://localhost:3030';
  }

  const host = window.location.hostname;
  const protocol = window.location.protocol;
  const isRemoteHost = !LOCAL_HOSTS.has(host);
  const isNativeRuntime =
    protocol === 'capacitor:' ||
    protocol === 'ionic:' ||
    Capacitor.isNativePlatform();

  // Capacitor serves bundled assets from a localhost-like origin. Without this
  // guard the app tries to call capacitor://localhost:3030 (iOS) or
  // https://localhost:3030 (Android) instead of the production API.
  if (isNativeRuntime) {
    return PRODUCTION_BACKEND_URL;
  }

  // On a real domain (e.g. leaguehub.it), use same-origin /api via Nginx proxy
  if (isRemoteHost && /\.[a-z]{2,}$/i.test(host)) {
    return `${protocol}//${host}`;
  }

  const runtimeUrl = `${protocol}//${host}:3030`;

  if (!envUrl) return runtimeUrl;

  // If a remote deployment still has a localhost env, force runtime server ip/domain.
  if (isRemoteHost && /localhost|127\.0\.0\.1/.test(envUrl)) {
    return runtimeUrl;
  }

  return envUrl;
}
